var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1261156358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 414",
    d: "M26.8769 4.92383H17.4307C17.3203 4.92383 17.2307 5.01337 17.2307 5.12383V18.2623C17.2307 18.3727 17.3203 18.4623 17.4307 18.4623H26.8769C26.9873 18.4623 27.0769 18.3727 27.0769 18.2623V5.12383C27.0769 5.01337 26.9873 4.92383 26.8769 4.92383Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 415",
    d: "M13.3385 4.92383H3.89238C3.78193 4.92383 3.69238 5.01337 3.69238 5.12383V11.4931C3.69238 11.6035 3.78193 11.6931 3.89238 11.6931H13.3385C13.449 11.6931 13.5385 11.6035 13.5385 11.4931V5.12383C13.5385 5.01337 13.449 4.92383 13.3385 4.92383Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 416",
    d: "M13.3385 14.7695H3.89238C3.78193 14.7695 3.69238 14.8591 3.69238 14.9695V28.108C3.69238 28.2184 3.78193 28.308 3.89238 28.308H13.3385C13.449 28.308 13.5385 28.2185 13.5385 28.108V14.9695C13.5385 14.8591 13.449 14.7695 13.3385 14.7695Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 417",
    d: "M26.8769 21.5391H17.4307C17.3203 21.5391 17.2307 21.6286 17.2307 21.7391V28.1083C17.2307 28.2188 17.3203 28.3083 17.4307 28.3083H26.8769C26.9873 28.3083 27.0769 28.2188 27.0769 28.1083V21.7391C27.0769 21.6286 26.9873 21.5391 26.8769 21.5391Z",
    fill: "#DCDCDC",
    stroke: "#DCDCDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangles);
export default __webpack_public_path__ + "static/media/rectangles.cddb7025bf3b33f06178a3034a6838e4.svg";
export { ForwardRef as ReactComponent };